import { usePathname } from 'next/navigation';

import useTranslation from '@/utils/hooks/translation/useTranslation';

import type { AlbumsCreateButtonProps } from '@/components/pages/albums/AlbumsCreateButton';
import AlbumsCreateButton from '@/components/pages/albums/AlbumsCreateButton';
// Types
import type { DropdownLinksType } from '@/components/layouts/LayoutPlatform/components/PageHeaderRecap';
// Components
import { PageHeaderRecap } from '@/components/layouts/LayoutPlatform/components/PageHeaderRecap';

// Lib
import { CONTENT_ALBUMS, CONTENT_ALBUMS_COMPARATIVE_TABLE } from '@/routes/privateRoutes';

type AlbumsPageHeaderRecapProps = {
    toggleAlbumFunnel: AlbumsCreateButtonProps['onClick'];
};

const AlbumsPageHeaderRecap = ({ toggleAlbumFunnel }: AlbumsPageHeaderRecapProps) => {
    const { t } = useTranslation();
    const pathname = usePathname();

    const dropdownLinks: DropdownLinksType = [
        { href: CONTENT_ALBUMS_COMPARATIVE_TABLE, label: t('content:albums_comparative_table') },
        { href: CONTENT_ALBUMS, label: t('content:albums') }
    ];

    return (
        <PageHeaderRecap
            title={dropdownLinks.find((link) => link.href === pathname)?.label}
            dropdownLinks={dropdownLinks}>
            {({ isSticky }) => (
                <AlbumsCreateButton size={isSticky ? 'sm' : 'md'} onClick={toggleAlbumFunnel} />
            )}
        </PageHeaderRecap>
    );
};

export default AlbumsPageHeaderRecap;
